import { useTranslation } from "react-i18next";
import notFoundIcon from "./NotFoundIcon.png";
import "./InvalidSlide.css";

export function InvalidSlide() {
  const { t } = useTranslation();
  return (
    <div className="invalid-slide">
      <img src={notFoundIcon} alt={t("carousel.slide.songsheetNotFound")} />
    </div>
  );
}
